<script setup>
import HomeGridItems from "~/components/molecules/HomeGridItems.vue";
import BasicBlock from "~/components/molecules/BasicBlock.vue";
import HorizontalMenu from "~/components/molecules/HorizontalMenu.vue";

const props = defineProps({
  data: Object,
  inContainer: Boolean | undefined | null
})

const hasHeader = computed(() => {
  return !!(props.data?.title || props.data?.right_corner_name)
})
</script>
<template>
  <div>
    <BasicBlock :mobileContainer="true">
      <template v-slot:title v-if="hasHeader">
        <div class="niche-header row" :class="{container:!inContainer}">
          <span v-if="data.title">{{ data.title }}</span>
          <nuxt-link
              v-if="data.right_corner_name && data.right_corner_url"
              :to="data.right_corner_url"
              class="right-corner"
          >
            {{ data.right_corner_name }}
          </nuxt-link>
        </div>
      </template>

      <template v-slot:default>
        <div class="mobile-container" v-if="data.menu && data.menu.length">
          <HorizontalMenu class="grid-menu" :class="{container:!inContainer}" :hide-on-mobile="false"
                          :items="data.menu"/>
        </div>

        <HomeGridItems :lazy="false" :items="data.slides"/>
      </template>
    </BasicBlock>
  </div>
</template>

<style scoped lang="scss">
.niche-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.right-corner {
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;
  flex-shrink: 0;

  @include smd {
    font-size: 12px;
  }
}

.mobile-container {
  @include mobile {
    margin: 0 17px;
  }
}
</style>
